import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=0a36f772&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=js&"
export * from "./Details.vue?vue&type=script&lang=js&"
import style0 from "./Details.vue?vue&type=style&index=0&id=0a36f772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a36f772",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a36f772', component.options)
    } else {
      api.reload('0a36f772', component.options)
    }
    module.hot.accept("./Details.vue?vue&type=template&id=0a36f772&scoped=true&", function () {
      api.rerender('0a36f772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Map/Details.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/Details.vue
// module id = nTz2
// module chunks = 0